import React from 'react';
import { Box, Typography } from '@mui/material';
import '../awsManual.css';

interface StepTitleProps {
  stepNumber: number;
  title: string;
}

const StepTitle: React.FC<StepTitleProps> = ({ stepNumber, title }) => {
  return (
    <Box className="stepTitleContainer">
      <div className="stepNumberBadge">{stepNumber}</div>
      <Typography variant="h5" fontWeight={600} className="stepTitleText">
        {title}
      </Typography>
    </Box>
  );
};

export default StepTitle;
